import { render, staticRenderFns } from "./superuser-my-account-customer-data.vue?vue&type=template&id=01c32809&"
import script from "./superuser-my-account-customer-data.vue?vue&type=script&lang=js&"
export * from "./superuser-my-account-customer-data.vue?vue&type=script&lang=js&"
import style0 from "./superuser-my-account-customer-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports